'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Checkbox = require('./Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _filters = require('../helpers/filters');

var _RangeSlider = require('./RangeSlider');

var _RangeSlider2 = _interopRequireDefault(_RangeSlider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Filters = function (_Component) {
  (0, _inherits3.default)(Filters, _Component);

  function Filters(props) {
    (0, _classCallCheck3.default)(this, Filters);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Filters.__proto__ || (0, _getPrototypeOf2.default)(Filters)).call(this, props));

    _this.state = {
      isOpen: false
    };

    _this.state = {
      filters: _lodash2.default.cloneDeep(props.filters),
      priceRange: {
        low: props.low,
        high: props.high
      }
    };
    return _this;
  }

  (0, _createClass3.default)(Filters, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        filters: nextProps.filters,
        priceRange: {
          low: nextProps.low,
          high: nextProps.high
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          i18n = _props.i18n,
          search = _props.search,
          types = _props.types,
          min = _props.min,
          max = _props.max,
          onSubmit = _props.onSubmit,
          isDisplayCount = _props.isDisplayCount;
      var isOpen = this.state.isOpen;
      var _state$priceRange = this.state.priceRange,
          low = _state$priceRange.low,
          high = _state$priceRange.high;


      var onChangeFilter = function onChangeFilter(id, checked) {
        var values = _lodash2.default.cloneDeep(_this2.state.filters);
        _lodash2.default.find(values, { id: id }).checked = checked;
        onSubmit({
          filters: values,
          priceRange: {
            low: low || min,
            high: high || max
          }
        });
      };

      var onChangePriceRange = function onChangePriceRange(low, high) {
        _this2.setState({
          priceRange: { low: low, high: high }
        });

        onSubmit({
          filters: _this2.state.filters,
          priceRange: {
            low: low,
            high: high
          }
        });
      };
      return _react2.default.createElement(
        'div',
        {
          className: 'filterbox ' + (isOpen ? 'opened-filter' : 'closed-filter')
        },
        _react2.default.createElement(
          'div',
          { className: 'filterbox-sub' },
          _react2.default.createElement(_RangeSlider2.default, {
            lang: i18n.lang,
            title: i18n.hotelInformation.price,
            unit: search.currency,
            max: max,
            min: min,
            high: high,
            low: low,
            isVisible: isOpen,
            onChange: function onChange(low, high) {
              onChangePriceRange(low, high);
            }
          })
        ),
        types.map(function (type) {
          return _react2.default.createElement(
            'div',
            { className: 'filterbox-sub', key: type },
            _react2.default.createElement(
              'div',
              { className: 'filter-meals' },
              _react2.default.createElement(
                'div',
                { className: 'filter-title' },
                i18n.filters[type]
              ),
              _react2.default.createElement(
                'div',
                { className: 'filter-items' },
                (0, _filters.find)(type, _this2.state.filters).map(function (item) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'filter-checkbox', key: '' + item.id },
                    _react2.default.createElement(_Checkbox2.default, {
                      id: item.id,
                      count: isDisplayCount ? Number(item.count) : undefined,
                      text: item.name,
                      checked: item.checked,
                      onChange: function onChange(id, checked) {
                        return onChangeFilter(id, checked);
                      }
                    })
                  );
                })
              )
            )
          );
        }),
        _react2.default.createElement(
          'div',
          { id: 'filterbar', className: isOpen ? 'toggle-opened' : 'toggle-closed' },
          _react2.default.createElement(
            'div',
            { className: 'filterbar-inner' },
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'open-button toggle-icon-box',
                onClick: function onClick() {
                  return _this2.setState({
                    isOpen: !isOpen
                  });
                }
              },
              _react2.default.createElement(
                'span',
                { className: 'toggle-title' },
                isOpen ? i18n.filters.closeFilters : i18n.filters.openFilters
              ),
              _react2.default.createElement('span', { className: 'toggle' })
            ),

            // show the price tag while high, low exists but not equals to default max, min value
            this.props.high && this.props.low && (this.props.high !== max || this.props.low !== min) ? _react2.default.createElement(
              'button',
              {
                className: 'filtered-button',
                onClick: function onClick(evt) {
                  evt.preventDefault();
                  onChangePriceRange(min, max);
                }
              },
              _react2.default.createElement(
                'span',
                { className: 'filter-button-title' },
                i18n.hotelInformation.price
              ),
              _react2.default.createElement('span', { className: 'icon-button-close' })
            ) : null,
            this.props.filters.filter(function (item) {
              return types.map(function (type) {
                return (0, _filters.find)(type, [item]);
              }).filter(function (item) {
                return item.length;
              }).length;
            }).filter(function (item) {
              return item.checked;
            }).map(function (item) {
              return _react2.default.createElement(
                'button',
                {
                  className: 'filtered-button',
                  key: item.id,
                  onClick: function onClick(evt) {
                    evt.preventDefault();
                    onChangeFilter(item.id, false);
                  }
                },
                _react2.default.createElement(
                  'span',
                  { className: 'filter-button-title' },
                  item.name
                ),
                _react2.default.createElement('span', { className: 'icon-button-close' })
              );
            })
          )
        )
      );
    }
  }]);
  return Filters;
}(_react.Component); // Filters

exports.default = Filters;


Filters.propTypes = {
  // TODO: the PropTypes does not work...
  // filters: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     id: PropTypes.string.isRequired,
  //     name: PropTypes.string.isRequired,
  //     count: PropTypes.number.isRequired
  //   })
  // ),
  i18n: _react.PropTypes.object.isRequired,
  search: _react.PropTypes.object.isRequired,
  filters: _react.PropTypes.array.isRequired,
  min: _react.PropTypes.number.isRequired,
  max: _react.PropTypes.number.isRequired,
  low: _react.PropTypes.number,
  high: _react.PropTypes.number,
  isDisplayCount: _react.PropTypes.bool,
  types: _react.PropTypes.array,
  // functions
  onSubmit: _react.PropTypes.func.isRequired
};

Filters.defaultProps = {
  types: ['rate', 'hotelFacility', 'roomFacility', 'meals']
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Filters.js
// module id = 573
// module chunks = 0